import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { EventContentObjectDataObject } from 'models/service';
import type { ProgramEventRequestData } from './create-program-event';

export const updateEvent = async (id: string, event: ProgramEventRequestData) =>
  apiClient.put<EventContentObjectDataObject, ApiClientResponse<EventContentObjectDataObject>>(
    routes.events.update(id),
    {
      event,
    },
  );
